import { Component } from "@angular/core";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { KpiCardComponent } from "../kpi-card/kpi-card.component";
import { NewUiKpiCarouselPanelComponent } from "./new-ui-kpi-carousel-panel.component";

@Component({
  selector: "app-kpi-carousel-panel",
  templateUrl: "./kpi-carousel-panel.component.html",
  styleUrl: "./kpi-carousel-panel.component.scss",
  imports: [TranslateDirective, KpiCardComponent],
})
export class KpiCarouselPanelComponent extends NewUiKpiCarouselPanelComponent {}
